/**
 * 무용연 회원 유형 단일 소스.
 *  - 가입/프로필/권한 매트릭스가 모두 이 코드를 참조한다.
 *  - 멀티 유형 보유 모델: 한 계정이 여러 유형을 가질 수 있고, 권한은 보유 유형의 합집합으로 판정한다.
 *    (constants/permissions.js 의 heldTypes 참고)
 */

import { SPACE_FEATURE_ENABLED } from "./featureFlags";

const ALL_MEMBER_TYPES = [
  { code: "ACADEMY", label: "학원·원장" },
  { code: "TEACHER", label: "강사" },
  { code: "TEAM", label: "공연팀·기획자" },
  { code: "DANCER", label: "무용수" },
  { code: "SPACE", label: "공간 보유자" },
  { code: "HOBBY", label: "일반회원" },
];

export const MEMBER_TYPES = ALL_MEMBER_TYPES.filter(
  (type) => SPACE_FEATURE_ENABLED || type.code !== "SPACE",
);

// 기존 코드 호환용 별칭 (mock 에서 쓰던 이름)
export const memberTypes = MEMBER_TYPES;

const LABEL_MAP = Object.fromEntries(MEMBER_TYPES.map((t) => [t.code, t.label]));

export const memberTypeLabel = (code) => LABEL_MAP[code] || (code ? "회원" : "");

// 코드 배열 → "강사, 무용수" 라벨 문자열
export const memberTypesLabel = (codes) =>
  Array.isArray(codes) ? codes.map(memberTypeLabel).join(", ") : memberTypeLabel(codes);

// 인증 대상 유형(서류 제출 → 관리자 승인 후 부여) + 제출 서류 안내.
//  ★ 2026-10-12 강사·무용수는 빠졌다 — 휴대폰 본인 인증만으로 바로 부여된다(IDENTITY_ROLES).
//   전공·경력·자격·지도경력은 선택 '전문 정보 확인'(/my/credentials)으로 따로 받는다.
export const BUSINESS_DOCS = {
  ACADEMY: "사업자등록번호·개업일자 (대표자 이름까지 국세청 정보와 맞으면 바로 승인, 사진은 선택)", // ★ 2026-10-22 국세청 확인 자동 승인
  SPACE: "사업자등록증 또는 임대차계약서",
  TEAM: "사업자등록증·고유번호증 또는 공연 증빙",
};

// 본인 인증만으로 바로 쓰는 유형(서버 common/roles.util IDENTITY_REQUIRED_ROLES 와 같은 목록)
export const IDENTITY_ROLES = ["TEACHER", "DANCER"];
export const IDENTITY_ROLE_HINT = "휴대폰 본인인증만 하면 바로 이용할 수 있어요. 전공·경력 확인은 원할 때 따로 신청하면 돼요.";

// 유형 해제 시 안내(발행 자산이 비공개되어 신규 유입이 끊긴다는 점 + 진행중은 유지).
export const REMOVE_WARNING = {
  TEACHER: "강사 유형을 해제하면 강사프로필이 비공개로 바뀌고 새 견적요청을 받을 수 없어요. 진행 중인 상담은 그대로 이용할 수 있어요. 다시 추가하면 복원돼요.",
  DANCER: "무용수 유형을 해제하면 무용수 프로필이 비공개로 바뀌고 새 캐스팅 제안을 받을 수 없어요. 다시 추가하면 복원돼요.",
  ACADEMY: "학원·원장 유형을 해제하면 등록한 채용·대타 공고가 숨겨지고 새 지원을 받을 수 없어요. 기존 지원자는 계속 확인할 수 있어요.",
  TEAM: "공연팀 유형을 해제하면 등록한 캐스팅 공고가 숨겨지고 새 지원을 받을 수 없어요. 다시 추가하면 복원돼요.",
  SPACE: "공간 보유자 유형을 해제하면 공간이 비노출될 수 있어요.",
  HOBBY: "",
};

// 그리드/상세 아바타 이모지(넷플릭스식 프로필 타일)
export const MEMBER_TYPE_EMOJI = {
  ACADEMY: "🏛️", TEACHER: "🩰", TEAM: "🎭", DANCER: "💃", SPACE: "🏢", HOBBY: "🌱",
};
